import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_child_entity_child_viewer_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.WORKSPACE_CHILD_ENTITY_VIEWER_DELETE,
  payload,
});

export const init_local_workspace_child_entity_child_viewer_delete = (state: STATE__workspace, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    state.child_entity_viewers_map.delete(id);
  }

  //refresh map to trigger re-render
  state.child_entity_viewers_map = new Map(state.child_entity_viewers_map);
};
